const FY26_COMPETITION_ID = 9;
const FY27_COMPETITION_ID = 10;
const BUFFALO_CLUB_ID = 5;
const PHILADELPHIA_CLUB_ID = 23;

/**
 * CLUBS contains the current-season settings. Keep historical DED share-model
 * calculations aligned with the season-specific preferences supplied by NHL.
 */
export const getCompetitionClubShareProfile = (club, competitionId) => {
  if (!club) return null;

  const profile = { ...club };
  const normalizedCompetitionId = Number(competitionId);

  if (normalizedCompetitionId === FY27_COMPETITION_ID) return profile;

  if (Number(profile.id) === BUFFALO_CLUB_ID) {
    profile.share = 'no';
  }

  if (Number(profile.id) === PHILADELPHIA_CLUB_ID) {
    profile.opt_out = normalizedCompetitionId !== FY26_COMPETITION_ID;
  }

  return profile;
};
